module.exports = __webpack_public_path__ + "static/img/11.bd9b279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/11.png
// module id = QLg9
// module chunks = 0